import {DriveLayout, StationLayout} from '@domain/kiln-monitoring'

export const checkKilnPartBoundaries = (
  kilnPart: StationLayout | DriveLayout,
  kilnLength: number
) => {
  const distanceFrom0InMeters = kilnPart.dimensions?.distanceFrom0
  const isKilnPartDistanceFrom0SetUp = distanceFrom0InMeters !== undefined

  const widthInMeters = kilnPart.dimensions?.width
  const isKilnPartWidthSetUp = widthInMeters !== undefined && widthInMeters > 0

  const areKilnPartBoundariesSetUp =
    isKilnPartDistanceFrom0SetUp &&
    isKilnPartWidthSetUp &&
    distanceFrom0InMeters >= 0 &&
    distanceFrom0InMeters + widthInMeters <= kilnLength

  return areKilnPartBoundariesSetUp
}
